export default "__VITE_ASSET__f12ec5e5__"